export const TEXTS = {
  LIKE: 'Нравится',
};
